import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
  import { RouteLocationRaw, useRouter } from 'vue-router';
  import urlJoin from 'url-join';

  export interface CustomLinkProps {
    to?: RouteLocationRaw,
    href?: string,
    customDomain?: string,
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    to: null,
    href: null,
    customDomain: null
  },
  setup(__props: any) {

const props = __props as {
    to?: RouteLocationRaw,
    href?: string,
    customDomain?: string,
  }

  
  const router = useRouter();

  const attrs = computed(() => {
    const { href, to, customDomain } = props;
    const attrsObj: CustomLinkProps = {};
    if (href) {
      attrsObj.href = href;
    } else if (customDomain && !customDomain.includes(location.host)) {
      // customDomain 可能带有 https 也可能没有
      attrsObj.href = urlJoin(customDomain, router.resolve(to || { name: 'home' }).fullPath);
    } else {
      attrsObj.to = to;
    }
    return attrsObj;
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(attrs).href ? 'a' : 'router-link'), _normalizeProps(_guardReactiveProps(_unref(attrs))), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}
}

})